<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import type { Component } from 'vue';

defineProps<{ is: Component }>();

const root = ref<HTMLElement | null>(null);
const visible = ref(false);
let observer: IntersectionObserver | null = null;

onMounted(() => {
    observer = new IntersectionObserver(
        ([entry]) => {
            visible.value = entry.isIntersecting;
        },
        { rootMargin: '120px', threshold: 0.01 },
    );

    if (root.value) {
        observer.observe(root.value);
    }
});

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
    <div ref="root">
        <component :is="is" v-if="visible" />
        <!-- Placeholder keeps the layout stable before the scene mounts -->
        <div
            v-else
            class="aspect-[100/58] min-h-[210px] w-full rounded-3xl border border-cyan-400/20 bg-slate-950"
        ></div>
    </div>
</template>
